import { MenuItem } from "@chakra-ui/react";
import { FragmentType, getFragmentData, gql } from "__generated__/gql";
import { brokerHome } from "utils/links";
import BrokerIcon from "components/Shared/BrokerIcon";
import MenuItemLink from "components/Layout/NavBar/MenuItemLink";

const fragment = gql(/* GraphQL */ `
  fragment BrokerAccountMenuItem on Broker {
    id
    name
    slug
    ...BrokerIcon
  }
`);

type Props = {
  broker: FragmentType<typeof fragment>;
  currentBrokerId?: UUID;
  onSelect?: () => void;
};

export default function BrokerAccountMenuItem({
  broker: brokerFragment,
  currentBrokerId,
  onSelect,
}: Props) {
  const broker = getFragmentData(fragment, brokerFragment);
  const isDisabled = currentBrokerId ? broker.id === currentBrokerId : false;

  return (
    <MenuItem
      as={MenuItemLink}
      href={brokerHome(broker.slug)}
      isDisabled={isDisabled}
      icon={<BrokerIcon broker={broker} boxSize="1.35em" />}
      onClick={onSelect}
    >
      {broker.name}
    </MenuItem>
  );
}
